import { Box, Stack, styled, Typography } from '@mui/material'
import LeftAreaBackgroundImageLogin from 'assets/images/left-area-login-background-image.png'
import LeftAreaBackgroundImageLogin1366 from 'assets/images/left-area-login-background-image-1366.png'
import MercadoLivreIcon from 'assets/icons/mercado-livre.png'
import ShopeeIcon from 'assets/icons/shopee.png'
import AmazonIcon from 'assets/icons/amazon.png'
import PlaceEcomeceLogos from 'assets/icons/place-moovin-store-logos.svg'
import LeftAreaLoginImageNotebook from 'assets/images/left-area-login-image-notebook.png'

const LeftAreaLoginRoot = styled('div', { name: 'LeftAreaLogin' })(({ theme }) => ({
  width: '100%',
  height: '100%',
  backgroundImage: `url(${LeftAreaBackgroundImageLogin})`,
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  backgroundSize: 'cover',

  '@media screen and (max-width: 1366px)': {
    backgroundImage: `url(${LeftAreaBackgroundImageLogin1366})`
  }
}))

export default function LeftAreaLogin() {
  return (
    <LeftAreaLoginRoot>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          padding: '30px'
        }}
      >
        <Stack
          sx={{
            textAlign: 'center',
            gap: '10px',
            width: '530px',
            marginBottom: '44px',
            '@media (max-height: 665px)': {
              marginBottom: '10px'
            }
          }}
        >
          <Typography
            sx={{
              fontFamily: 'Poppins',
              fontSize: '35px',
              fontWeight: 500,
              color: '#FFF',
              lineHeight: '20px',
              '@media (max-height: 665px)': {
                fontSize: '30px'
              }
            }}
          >
            Venda mais com os maiores{' '}
            <Typography
              component="span"
              sx={{
                fontSize: '35px',
                color: '#00FF9D',
                '@media (max-height: 665px)': {
                  fontSize: '30px'
                }
              }}
            >
              marketplaces do Brasil!
            </Typography>
          </Typography>

          <Typography
            sx={{
              fontFamily: 'Open Sans',
              fontSize: '16px',
              color: '#FFF'
            }}
          >
            Aumente a visibilidade da sua conta e alcance milhões de compradores todos os meses.
          </Typography>
        </Stack>

        <Stack
          direction="row"
          gap="25px"
          alignItems="center"
          sx={{
            marginBottom: '64px',
            '@media (max-height: 665px)': {
              marginBottom: '20px'
            }
          }}
        >
          <img src={LeftAreaLoginImageNotebook} alt="" width={342} height={346} />

          <Stack gap="30px">
            <Stack direction="row" gap="15px" alignItems="center">
              <img src={MercadoLivreIcon} alt="" width={50} height={50} />

              <Typography
                fontFamily="Open Sans"
                fontSize="18px"
                color="#FFF"
                maxWidth="220px"
                lineHeight="20px"
              >
                <Typography component="span" color="#00FF9D" fontSize="18px" fontWeight={600}>
                  366 milhões
                </Typography>{' '}
                de acessos no Mercado Livre
              </Typography>
            </Stack>
            <Stack direction="row" gap="15px" alignItems="center">
              <img src={ShopeeIcon} alt="" width={50} height={50} />

              <Typography
                fontFamily="Open Sans"
                fontSize="18px"
                color="#FFF"
                maxWidth="220px"
                lineHeight="20px"
              >
                <Typography component="span" color="#00FF9D" fontSize="18px" fontWeight={600}>
                  244 milhões
                </Typography>{' '}
                na Shopee
              </Typography>
            </Stack>
            <Stack direction="row" gap="15px" alignItems="center">
              <img src={AmazonIcon} alt="" width={50} height={50} />

              <Typography
                fontFamily="Open Sans"
                fontSize="18px"
                color="#FFF"
                maxWidth="220px"
                lineHeight="20px"
              >
                <Typography component="span" color="#00FF9D" fontSize="18px" fontWeight={600}>
                  209 milhões
                </Typography>{' '}
                na Amazon Brasil
              </Typography>
            </Stack>
          </Stack>
        </Stack>

        <Box>
          <img src={PlaceEcomeceLogos} alt="" />
        </Box>
      </Box>
    </LeftAreaLoginRoot>
  )
}
